module.exports = __webpack_public_path__ + "c7f1a344b90a0737aa9aa5d82da07caa.svg";